/**
 * BLAKIN — barre d'achat sticky mobile.
 *
 * Affiche la barre quand le bouton d'ajout principal est sorti du viewport
 * par le haut, et garde le prix affiché synchronisé avec le bloc prix de la
 * page (mis à jour par Dawn à chaque changement de variante).
 */
if (!customElements.get('bk-barre-achat')) {
  customElements.define(
    'bk-barre-achat',
    class BkBarreAchat extends HTMLElement {
      connectedCallback() {
        this.cible = document.getElementById(this.dataset.cible);
        this.prixEl = this.querySelector('[data-bk-prix]');
        this.sourceEl = this.dataset.source ? document.querySelector(this.dataset.source) : null;

        if (!this.cible) return;

        this.visibiliteObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              // Masquée tant que le bouton principal est visible ou encore plus bas
              // dans la page ; visible uniquement une fois qu'il est passé au-dessus.
              this.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
            });
          },
          { rootMargin: '0px 0px -80px 0px' }
        );
        this.visibiliteObserver.observe(this.cible);

        if (this.sourceEl && this.prixEl) {
          this.synchroniserPrix = this.synchroniserPrix.bind(this);
          this.prixObserver = new MutationObserver(this.synchroniserPrix);
          this.prixObserver.observe(this.sourceEl, {
            childList: true,
            subtree: true,
            characterData: true,
          });
          this.synchroniserPrix();
        }
      }

      disconnectedCallback() {
        if (this.visibiliteObserver) this.visibiliteObserver.disconnect();
        if (this.prixObserver) this.prixObserver.disconnect();
      }

      synchroniserPrix() {
        const bloc = this.sourceEl.querySelector('.price') || this.sourceEl;
        const enPromo = bloc.classList.contains('price--on-sale');
        const noeud = enPromo
          ? bloc.querySelector('.price-item--sale')
          : bloc.querySelector('.price-item--regular');

        const texte = noeud ? noeud.textContent.trim() : '';
        if (texte) this.prixEl.textContent = texte;
      }
    }
  );
}
